export default __webpack_public_path__ + "static/media/stethoscope.60144dd5.svg";